import { render } from "./EditHorizontalBarChart.vue?vue&type=template&id=5273d9ca"
import script from "./EditHorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./EditHorizontalBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__